(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.receiptUploadValidation = {
        attach: function (context) {
            const fileInput = once('receipt-upload-validation', 'input[name="files[upload_receipt]"]', context)[0];
            if (!fileInput) return;

            // Configuration
            const MAX_FILE_SIZE = 4 * 1024 * 1024; // 4MB in bytes
            const ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
            const ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.png'];

            // Create error message container
            const errorContainer = document.createElement('div');
            errorContainer.className = 'receipt-upload-error alert alert-danger mt-2';
            errorContainer.style.display = 'none';
            errorContainer.setAttribute('role', 'alert');

            // Create file info container
            const fileInfoContainer = document.createElement('div');
            fileInfoContainer.className = 'receipt-upload-info mt-2';
            fileInfoContainer.style.display = 'none';

            // Insert containers after the file input wrapper
            const fileWrapper = fileInput.closest('.js-webform-image-file');
            if (fileWrapper) {
                fileWrapper.parentNode.insertBefore(errorContainer, fileWrapper.nextSibling);
                fileWrapper.parentNode.insertBefore(fileInfoContainer, errorContainer.nextSibling);
            }

            // Display error message
            const showError = (message) => {
                errorContainer.textContent = message;
                errorContainer.style.display = 'block';
                errorContainer.setAttribute('aria-live', 'assertive');
                
                // Add error styling to file input
                fileInput.classList.add('is-invalid');
                
                // Hide file info when showing error
                fileInfoContainer.style.display = 'none';
                
                // Scroll error into view
                errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            };

            // Clear error message
            const clearError = () => {
                errorContainer.style.display = 'none';
                errorContainer.textContent = '';
                fileInput.classList.remove('is-invalid');
            };

            // Show file info
            const showFileInfo = (file) => {
                const fileExtension = file.name.split('.').pop().toUpperCase();
                const fileSizeKB = (file.size / 1024).toFixed(2);
                const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
                const sizeDisplay = file.size > 1024 * 1024 ? `${fileSizeMB} MB` : `${fileSizeKB} KB`;
                
                fileInfoContainer.innerHTML = `
                    <div class="file-info-content d-flex align-items-center">
                        <svg width="16" height="16" fill="currentColor" class="me-2" viewBox="0 0 16 16">
                            <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
                            <path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2.002 3h10a2 2 0 0 1 2 2v8z"/>
                        </svg>
                        <span><strong>${file.name}</strong> (${fileExtension}, ${sizeDisplay})</span>
                    </div>
                `;
                fileInfoContainer.style.display = 'block';
            };

            // Clear file info
            const clearFileInfo = () => {
                fileInfoContainer.style.display = 'none';
                fileInfoContainer.innerHTML = '';
            };

            // Validate file
            const validateFile = (file) => {
                // Check if file exists
                if (!file) {
                    return { valid: true };
                }

                // Validate file type
                const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
                const isValidType = ALLOWED_TYPES.includes(file.type) || ALLOWED_EXTENSIONS.includes(fileExtension);
                
                if (!isValidType) {
                    return {
                        valid: false,
                        message: 'Sorry, the receipt image you have uploaded is not in the approved file format.'
                    };
                }

                // Validate file size
                if (file.size > MAX_FILE_SIZE) {
                    return {
                        valid: false,
                        message: 'The receipt image you have uploaded is over the size limit.'
                    };
                }

                return { valid: true };
            };

            // Handle file selection - use capture phase to intercept before Drupal's handlers
            fileInput.addEventListener('change', function(event) {
                const file = event.target.files[0];
                
                // If no file selected, clear everything
                if (!file) {
                    clearFileInfo();
                    return;
                }

                const validation = validateFile(file);

                if (!validation.valid) {
                    // Stop all event propagation to prevent Drupal's auto-upload
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    
                    // Show error message
                    showError(validation.message);
                    
                    // Clear file info
                    clearFileInfo();
                    
                    // Clear the file input after a tiny delay to ensure error shows
                    setTimeout(() => {
                        event.target.value = '';
                    }, 100);
                    
                    return false;
                } else {
                    // Valid file - clear any existing errors and show file info
                    clearError();
                    showFileInfo(file);
                }
            }, true); // Use capture phase

            // Additional validation on form submit
            const form = fileInput.closest('form');
            if (form) {
                form.addEventListener('submit', function(event) {
                    const file = fileInput.files[0];
                    
                    // Only validate if a file is selected
                    if (file) {
                        const validation = validateFile(file);
                        
                        if (!validation.valid) {
                            showError(validation.message);
                            event.preventDefault();
                            event.stopPropagation();
                            return false;
                        }
                    }
                }, true);
            }
        }
    };

})(Drupal, once);